var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <strong>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"tasksMade") : depth0), depth0))
    + "</strong>\n        <span>"
    + alias1(__default(require("../../../../../../util/handlebarsHelpers/__.js")).call(alias2,"made",{"name":"__","hash":{},"data":data,"loc":{"start":{"line":5,"column":14},"end":{"line":5,"column":27}}}))
    + "</span>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"finiteScore") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":9,"column":15}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <strong>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"score") : depth0), depth0))
    + "</strong>\n            <span>"
    + alias1(__default(require("../../../../../../util/handlebarsHelpers/__.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"score",{"name":"__","hash":{},"data":data,"loc":{"start":{"line":8,"column":18},"end":{"line":8,"column":32}}}))
    + "</span>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <strong>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"progress") : depth0), depth0))
    + "</strong>\n        <span>"
    + alias1(__default(require("../../../../../../util/handlebarsHelpers/__.js")).call(alias2,"made",{"name":"__","hash":{},"data":data,"loc":{"start":{"line":12,"column":14},"end":{"line":12,"column":27}}}))
    + "</span>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"scoreVisible") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":16,"column":15}}})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-progress-student tile__navigation__btn\">\n    <div class=\"js-progress-bar tile__navigation__progress-bar\"></div>\n"
    + ((stack1 = __default(require("../../../../../../util/handlebarsHelpers/isEqual.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"adaptive",{"name":"isEqual","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(2, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":17,"column":16}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});